import * as React from 'react';

/** Replaces `next/dynamic` when bundling the standalone widget with esbuild. */
export default function dynamic(
  loader: () => Promise<{ default: React.ComponentType<Record<string, unknown>> }>,
  opts?: { ssr?: boolean; loading?: () => React.ReactNode },
) {
  const Lazy = React.lazy(loader);
  return function DynamicComponent(props: Record<string, unknown>) {
    return (
      <React.Suspense fallback={opts?.loading?.() ?? null}>
        <Lazy {...props} />
      </React.Suspense>
    );
  };
}
